import React from "react";
import "./SubscriptionFailed.css";

const SubscriptionFailed = ({ onResend }) => {
    return (
        <div className="subscription-container">
            <div className="subscription-card error">
                <div className="icon-wrapper">
                    <span className="error-icon">✖</span>
                </div>

                <h2 className="title">Subscription Not Confirmed</h2>

                <p className="message">
                    We couldn’t verify your email address.
                    <br />
                    Please check your inbox and click the verification link to complete your subscription.
                </p>


                <a href="/" className="primary-btn">Resend Confirmation Email</a>


                <p className="helper-text">
                    Didn’t receive the email? Check your spam folder.
                </p>
            </div>
        </div>
    );
};

export default SubscriptionFailed;
